(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('MessagesPortalTemplateOverviewController', messagesPortalTemplateOverviewController)

  messagesPortalTemplateOverviewController.inject = ['ngTableParams', '$state', 'FoundationApi', 'MessagesPortalTemplateService', 'NotificationService', 'LangService']

  function messagesPortalTemplateOverviewController (ngTableParams, $state, FoundationApi, MessagesPortalTemplateService, NotificationService, LangService) {
    var vm = this;
    vm.filters = {
      channel_id: '',
      sector_id: ''
    }
    vm.searchTemplateTable = searchTemplateTable;
    vm.selectToRemove = selectToRemove;
    vm.remove = remove;
    vm.cancelRemove = cancelRemove;
    vm.edit = edit;

    LangService
      .getPageLabels({ 'page': 'menu.messagesPortal.messagesOverview' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    function edit (template) {
      $state.go('main.messages-portal-create', { 'id': template._id });
    }

    vm.messagesPortalTemplateToRemove = '';

    searchTemplateTable();

    function searchTemplateTable () {
      vm.templatesTable = new ngTableParams({
        page: 1, // show first page
        count: 10 // count per page
      }, {
        counts: [25, 50, 100],
        getData: function ($defer, params) {
          var obj = params.url();

          MessagesPortalTemplateService
            .getAllDetailed(obj)
            .$promise
            .then(function (data) {
              $defer.resolve(data.templates);
              params.total(data.templates);
              if (!data.templates) {
                NotificationService.errorHandler(data, vm.labels.errorLoadingMessages);
              }
            }).catch(function (data) {
              NotificationService.errorHandler(data, vm.labels.errorLoadingMessages);
              vm.total = 0;
            });
        }
      });
    }

    function selectToRemove (messagesPortalTemplate) {
      FoundationApi.publish('messagesPortalTemplateConfirmationModal', 'open');
      vm.messagesPortalTemplateToRemove = messagesPortalTemplate;
    }

    function remove () {
      if (vm.messagesPortalTemplateToRemove) {
        MessagesPortalTemplateService
          .delete(vm.messagesPortalTemplateToRemove)
          .$promise
          .then(function (data) {
            NotificationService.successHandler(data, vm.labels.successRemoveMessage);
            FoundationApi.publish('messagesPortalTemplateConfirmationModal', 'close');
            searchTemplateTable();
          }).catch(function (data) {
            NotificationService.errorHandler(data, vm.labels.errorRemoveMessage);
          })
      } else {
        NotificationService.errorHandler(vm.labels.noDataSelected, vm.labels.noDataSelected);
      }
    }

    function cancelRemove () {
      FoundationApi.publish('messagesPortalTemplateConfirmationModal', 'close');
    }
  }
})();
